import { UILogicController } from "@view/root/__proto__/withController";
import { IMainLayout } from "@shared/containers/Layout/connector/__types__/UIViewController";
import { LoginViewModel } from "@viewModels/LoginViewModel/LoginViewModel";
import { ILoginViewModel } from "@viewModels/LoginViewModel/__types__/ILoginViewModel";
import { IRootTreeModel } from "domain/models";

class MainLayoutController extends UILogicController implements IMainLayout {
  private LoginViewModel: ILoginViewModel;

  public constructor(model: IRootTreeModel) {
    super(model);

    this.LoginViewModel = new LoginViewModel(model);
  }

  public get isRequestInProgress(): boolean {
    return true;
  }

  public logout(): void {
    this.LoginViewModel.logout();
  }

  public beforeDestroy = (): void => {};
}

export { MainLayoutController };
